package com.patronat.top.ui.models

data class VenueMainInfoData(
    val name: String = "",
    val category: SelectOption? = null,
    val phone: String = "",
    val website: String = "",
    val description: String = ""
)
